<template>
	<div class="root">
		<MeetingHeader/>
		<div class="container">
			<div class="header">
				<img class="room-img" src="@/assets/shmeeting/room1.jpg" alt="">
				<div class="h-middle">
					<h3 class="meeting-center">多特瑞上海旗舰店</h3>
					<div class="order-desc">
						<div class="meeting-room">会议室1 (大)</div>
						<div class="timerange">2021-08-08 10:00 - 11:00</div>
						<div class="money">￥200</div>
					</div>
					<div class="order-desc">
						<div class="meeting-room">VIP2 (按摩)</div>
						<div class="timerange">2021-08-09 10:00 - 11:00</div>
						<div class="money">￥200</div>
					</div>
					<div class="order-desc">
						<div class="meeting-room">一次性按摩工具(1)套</div>
						<div class="money">￥200</div>
					</div>
					<div>订单编号: 56457875488</div>
				</div>
				<div class="h-right">
					应付金额<span class="total">￥188元</span>
				</div>
			</div>
			<div class="paychannels">
				<div class="item" @click="payChannel=4">
					<div class="left"><Checkbox size='large' class='checkbox' v-model="single">{{''}}</Checkbox></div>
					<div class="right">
						<img class="pay-img" src="@/assets/order/manyPay.png">
						<div>支持微信、支付宝、云闪付扫码支付</div>
					</div>
				</div>
				<div class="item align" @click="payChannel=1">
					<div class="left"><Checkbox size='large' class='checkbox' v-model="single">{{''}}</Checkbox></div>
					<div class="right">
						<img class="pay-img" src="@/assets/order/alipay.png">
						<div>支付宝</div>

					</div>
				</div>
				<div class="item" @click="payChannel=3">
					<div class="left"><Checkbox size='large' class='checkbox' v-model="single">{{''}}</Checkbox></div>
					<div class="right">
						<img class="pay-img" src="@/assets/order/unionpay.png">
						<div>单笔订单超20000元建议使用银联支付</div>
					</div>
				</div>
			</div>
			<div class="bottom">
				<Button @click='goResult' size='large' class='pay-btn' type='primary'>支付</Button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import MeetingHeader from '@/components/header/MeetingHeader'
	export default {
		data() {
			return {
				payChannel:0,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			MeetingHeader,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){

			},
			goResult(){
				this.$router.push('/meeting/payresult')
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.root {
		display:block;
		background-color: #eee;
	}
	.container {
		background-color: #eee;
		padding-top:1rem;
		margin:auto;
		max-width: 1400px;
	}
	.header {
		display:flex;
		background-color: white;
		padding:30px;
		border-radius: 20px;
		.room-img {
			width:150px;
			height:150px;
			border-radius: 20px;
			object-fit: cover;
		}
		.order-desc {
			display:flex;
			margin-bottom: 10px;
			.meeting-room,.timerange {
				margin-right: 20px;
				@include fontSize($font-size-16);
			}
			.money {
				color:red;
			}
		}
		.h-middle {
			margin-left: 20px;
			flex:1;
		}
		.h-right {
			margin-left: 20px;
			display:flex;
			align-items: center;
			justify-content: center;
			@include fontSize($font-size-24);
			.total {
				color:red;
				font-weight: bold;
				margin-left: 10px;
			}
		}
		.meeting-center {
			@include fontSize($font-size-24);
			margin-bottom: 10px;
		}
	}
	.paychannels {
		background-color: white;
		padding:30px;
		margin-top: 30px;
		border-radius: 20px;
		.item {
			display:flex;
			align-items: center;
			padding:20px 0;
			cursor: pointer;
			&:not(:last-child){
				border-bottom: 1px solid #eee;
			}
			.left {
				margin-right: 20px;
			}
			.right {
				display:flex;
				align-items: center;
				.pay-img {
					width:80px;
				}
				div {
					margin-left: 20px;
					@include fontSize($font-size-18);
				}
			}
		}
	}
	.bottom {
		display:flex;
		margin:30px 0;
		justify-content: center;
		.pay-btn {
			width:330px;
			border-radius: 30px;
			height:50px;
		}
	}
	@media (max-width: 768px){
		.container {
			padding-top: 2.4rem;
		}
		.header {
			padding:0px;
			padding-bottom: 10px;
			position:relative;
			flex-direction: column;
			.room-img {
				width:100%;
				height:150px;
				border-radius: 20px;
				object-fit: cover;
			}
			.meeting-center {
				margin-top: 10px;
				font-size: 14px;
			}
			.order-desc {
				.meeting-room,.timerange {
					margin-right: 10px;
					font-size: 14px;
				}
				
			}
			.h-right {
				justify-content: flex-start;
				font-size: 16px;
				margin-top: 10px;	
			}
		}
	}
</style>